import { Publication } from './../interfaces/publication';
import { PublicationService } from './../services/publication.service';
import { SapiService } from './../services/sapi.service';
import { AssetService } from './../services/asset.service';
import { Pipe, PipeTransform, ElementRef } from '@angular/core';
// import { Project } from 'app/interfaces/project';

// hmn
declare let Promise: any;

@Pipe({name: 'thumbnail'})

export class ThumbnailPipe implements PipeTransform {

	constructor(
		private sapiService: SapiService,
		private assetService: AssetService,
		private elRef: ElementRef,
		private publicationService: PublicationService) {

	}

	transform(entity: any, width?: number|string, height?: number|string, returnType?: string, transcoding?: boolean): Promise<any> {
		if (entity.mediatype === 'document') {
			return new Promise((resolve: any) => {
				resolve(`<div class="thumbnail-document-placeholder"><i class="fas fa-file" title="document" aria-hidden="true"></i></div>`);
			});
		}
		let wasString = false;
		if (typeof entity === 'string') {
			wasString = true;
			entity = {id: entity, type: 'mediaclip'};
		}

		if (entity && entity.type) {
			entity = {
				...entity,
				...{ type: entity.type.toLowerCase() }
			};
		}

		if ((entity && entity.type === 'project' && ! entity.mainMediaClipId && ( ! entity.thumbnails || ! entity.thumbnails.length) ) ||
			(entity.type === 'mediaclip' && !wasString && (
				entity.mediatype === 'video' && (!entity.thumbnails || (!entity.thumbnails.length || entity.isEmpty === true)))) ||
				entity.mediatype === 'image' && entity.isEmpty === true
		) {
			return new Promise((resolve: any) => {
				if (transcoding) {
					resolve(`<div class="thumbnail-placeholder"></div>`);
				} else {
					resolve ('');
				}
			});
		}

		let extension = 'jpg'; // default

		if (typeof entity.originalfilename !== 'undefined') {
			const file_extension = entity.originalfilename.trim().split('.').pop();

			if (file_extension === 'png') { // or... other supported formats?
				extension = file_extension;
			}
		}

		const returnPromise = new Promise((resolve: any, reject: any) => {
			this.publicationService.getData().subscribe((pubData: Publication) => {
				// a bit dirty but we know the assetservice depends on this data
				if (pubData) {
					let thumbUrl = this.assetService.getMainThumbnailResizerUrl(
						entity.id, width, height, extension, (entity.type ? entity.type.toLowerCase() : 'mediaclip'));
					const sessionToken = this.sapiService.getSessionToken();
					if (thumbUrl) {
						if (sessionToken) {
							thumbUrl += '?sesstoken=' + sessionToken;
						}
						if (returnType === 'url') {
							resolve( thumbUrl );
						} else if (returnType === 'backgroundUrl') {
							resolve( `url("${ thumbUrl }")` );
						} else {
							const img = document.createElement('IMG');
							img.setAttribute('alt', '');
							img.onerror = () => {
								this.elRef.nativeElement?.parentElement?.classList.add('thumbnail-load-error');
							};
							img.setAttribute('src', thumbUrl);
							resolve( `<img src="${ thumbUrl }" alt="" />` );
						}
					} else {
						resolve('');
					}
				}
			});
		});

		return returnPromise;
	}
}
